import type { PropsWithChildren, ReactNode } from 'react';
import React, { useId } from 'react';
import { tv } from 'tailwind-variants';
import { cn, type VariantProps } from '#pie/utils/TailwindUtils';

export interface DescriptionListItemProps
  extends VariantProps<typeof styles>,
    PropsWithChildren {
  children: React.ReactNode;
  direction?: 'horizontal' | 'vertical';
  full?: boolean;
  title: string | ReactNode;
}

export function DescriptionListItem({
  children,
  direction = 'horizontal',
  full = false,
  title,
}: DescriptionListItemProps) {
  const Wrapper = direction === 'horizontal' ? React.Fragment : 'div';
  const s = styles({ direction });
  const id = useId();

  return (
    <Wrapper>
      <dt className={cn(s.descriptionTerm(), full && 'col-span-full')} id={id}>
        {title}
      </dt>
      {/** biome-ignore lint/a11y/useAriaPropsSupportedByRole: This is probably fine */}
      <dd
        className={cn(s.descriptionDetail(), full && 'col-span-full')}
        aria-labelledby={id}
      >
        {children}
      </dd>
    </Wrapper>
  );
}

const styles = tv({
  slots: {
    descriptionDetail: 'text-content-body',
    descriptionTerm: 'font-bold',
  },
  variants: {
    direction: {
      horizontal: {
        descriptionDetail: 'flex-start -mt-5 flex xl:mt-0',
        descriptionTerm: 'min-w-[14rem]',
      },
      vertical: {
        descriptionDetail: 'flex-start',
        descriptionTerm: '',
      },
    },
  },
});
